import React, { useContext } from 'react';
import Button from '../../lds/Button';
import { TableContext } from './ListTable';
import Row from "@reactComponents/lds/table/Row";
import Cell from "@reactComponents/lds/table/Cell";
import Icon from "@reactComponents/lds/Icon";
import Header from "@reactComponents/lds/table/Header";

function ListTableHeader() {
  const { showHeader, editable, enableDeleteBtn, onDeleteButtonClick } = useContext(TableContext);

  let deleteButton = null;

  if (editable) {
    const variant = enableDeleteBtn ? "critical" : "disable";

    deleteButton = (
      <Cell header minWidth="72px" justify="center">
        <Button
          id="delete_lists"
          size="small"
          variant={variant}
          onClick={onDeleteButtonClick}
          width="40px"
          style={{ minWidth: 0 }}
        >
          <Icon name="delete" />
        </Button>
      </Cell>
    );
  }

  return (
    <>
      {
        showHeader &&
        <Header>
          <Row header>
            <Cell header>List Name</Cell>
            <Cell header minWidth="90px">Entries</Cell>
            {deleteButton}
          </Row>
        </Header>
      }

    </>
  )
}

export default ListTableHeader;
